export default __webpack_public_path__ + "static/media/navbar-icon-permission.e40a4259.svg";